import { Modal } from 'flowbite-react';
import { FormikProvider, useFormik } from 'formik';

import { useToastContext } from '../../../../common/components/ui/toast/toast.context';
import ButtonWithLoader from '../../../../common/components/ui/loading/ButtonLoading';

import { useEffect, useMemo, useState } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { convertLeadToRenter } from '../../../../common/services/leads.api';

type Props = {
  lead: { _id: string, name: string }
  onClose: () => void
}

export default function ModalConvertLead(props: Props) {
  const { notifySuccess, notifyError } = useToastContext()
  const [isConverted, setIsConverted] = useState(false);
  const [submitResult, setSubmitResult] = useState<string | null>(null);

  const formik = useFormik({
    initialValues: {
      leadId: props.lead._id,
      name: props.lead.name
    },
    onSubmit: async (data) => {
      const activationData = {
        leadId: data.leadId
      }
      const result = await convertLeadToRenter(activationData)
      if (!result.ok) {
        notifyError(result.message as string)
        setSubmitResult('error');
        return
      }
      notifySuccess("Conversão realizada com sucesso!")
      setSubmitResult('success');
    }
  })
  const badgeColor = useMemo(() =>
    (submitResult == "success")
      ? 'text-greenPrimary'
      : 'text-redPrimary'
    , [submitResult])

  useEffect(() => {
    setIsConverted(submitResult === 'success')
  }, [submitResult]);

  return (
    <Modal
      className='relative dark:text-black '
      show={true}
      onClose={() => props.onClose()}
    >
      <form onSubmit={formik.handleSubmit}>
        <FormikProvider value={formik}>
          <Modal.Header className='dark:text-black'>
            <h2 className='dark:text-black'>Converter {props.lead.name}</h2>
          </Modal.Header>

          <Modal.Body className='w-full relative items-center justify-center border-gray flex flex-col' style={{ minHeight: 'calc(80vh - 200px)', height: 'calc(50vh - 100px)' }}>
            <div className='pb-[24px]'>
              <h2 className="font-semibold ">Clique aqui para transformar Lead em Cliente:</h2>
            </div>
            <div className="grid-div2">
              <ButtonWithLoader
                isLoading={formik.isSubmitting}
                disabled={isConverted}
                onSave={() => setIsConverted(true)}>
                Converter
              </ButtonWithLoader>

              <FaCheckCircle size={24} className={`${badgeColor}`} />
            </div>
          </Modal.Body>
        </FormikProvider>
      </form>

      <Modal.Footer>
      </Modal.Footer>

    </Modal >
  );
}
